/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FloatingArrow, type FloatingContext } from '@floating-ui/react';

import { ARROW_HEIGHT, ARROW_WIDTH } from 'bundles/cds-labs/components/Tooltip/constants';
import type { Placement } from 'bundles/cds-labs/components/Tooltip/types';
import { getArrowOffset } from 'bundles/cds-labs/components/Tooltip/utils';

type Props = {
  placement: Placement;
  tooltipElement?: HTMLElement | null;
  context?: FloatingContext;
  className?: string;
  'data-testid'?: string;
};

export default React.forwardRef<SVGSVGElement, Props>(
  ({ context: floatingContext, className, 'data-testid': dataTestId, tooltipElement, placement }, ref) => {
    const context =
      floatingContext ??
      // this fallback is used for statically positioned tooltips when the
      // Tooltip component is used directly without FloatingTooltip
      ({
        placement,
        elements: { floating: tooltipElement, reference: null, domReference: null },
        middlewareData: { arrow: getArrowOffset(placement) },
      } as FloatingContext);

    return (
      <FloatingArrow
        ref={ref}
        context={context}
        height={ARROW_HEIGHT}
        width={ARROW_WIDTH}
        fill="var(--tooltip-background-color)"
        tipRadius={3}
        className={className}
        data-testid={dataTestId}
      />
    );
  }
);
